import Swiper from 'swiper';
import 'swiper/css';
import { Autoplay, Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/pagination';

import {
    selectAll,
    getRightGutter,
    equalizeSlidesHeight,
    resetSwiperInlineHeights,
    attachImageLoadEqualizer,
    debounce,
} from '../simplerToolkit.js';

document.addEventListener('DOMContentLoaded', () => {
    const carousels = selectAll('section.cards .swiper');
    if (!carousels || !carousels.length) return;

    const baseBreakpoints = {
        650: {slidesPerView: 2.25, spaceBetween: 16},
        768: {slidesPerView: 3.25, spaceBetween: 20},
        1024: {slidesPerView: 4, spaceBetween: 24},
    };

    const registry = [];

    carousels.forEach(el => {
        const edgeRight = el.classList.contains('edge-right');
        const instance = new Swiper(el, {
            modules: [Autoplay, Pagination],
            slidesPerView: 1.25,
            spaceBetween: 16,
            watchOverflow: true,
            loop: !edgeRight,
              autoplay: {
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },

            pagination: {
                el: el.querySelector('.swiper-pagination'),
                clickable: true,
            },
            breakpoints: baseBreakpoints,
            ...(edgeRight ? {slidesOffsetAfter: getRightGutter(el)} : {}),
        });
        registry.push({el, instance, edgeRight});

        const runEq = () => {
            requestAnimationFrame(() => {
                resetSwiperInlineHeights(el);
                equalizeSlidesHeight(el);
                if (instance.update) instance.update();
            });
        };
        instance.on && instance.on('init', runEq);
        instance.on && instance.on('breakpoint', runEq);
        runEq();
        attachImageLoadEqualizer(el, runEq);
    });

    window.addEventListener('resize', debounce(() => {
        registry.forEach(({el, instance, edgeRight}) => {
            if (!edgeRight) return;
            instance.params.slidesOffsetAfter = getRightGutter(el);
            resetSwiperInlineHeights(el);
            equalizeSlidesHeight(el);
            instance.update();
        });
    }));
});
